import React from 'react';

interface Props {
    subject: string;
		showSubject?: boolean;
    title: string;
    description?: string;
}

const HeroTitle = ({subject, showSubject = true, title, description}: Props) => {
    return (
        <div className="mx-auto max-w-4xl text-center pt-10 sm:pt-14">
					{showSubject && <h1 className="text-base/7 font-semibold text-indigo-600">{subject}</h1>}
            <p className="mt-2 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-6xl">
                {title}
            </p>
            {description &&
                <p className="mx-auto mt-6 max-w-4xl text-pretty text-center text-lg font-medium text-gray-600 sm:text-xl/8">
                    {description}
                </p>
            }
        </div>
    );
};

export default HeroTitle;
